<template>
  <div>
    <div class="container">
      <router-view />
    </div>
  </div>
</template>

<script lang="ts">
import { mapGetters } from 'vuex';
import trackSeekerAccountCreation from '@/lib/tracking/segment_track_basic';
import { Account } from '@/models/account';

export default {
  name: 'Registration',
  computed: {
    ...mapGetters('account', ['getAccount']),
    account(): Account | null {
      return this.getAccount;
    },
  },
  mounted() {
    if (this.account) {
      const accountProperties = this.getAccountPropertiesForTracking();
      trackSeekerAccountCreation(accountProperties);
    }
  },
  methods: {
    getAccountPropertiesForTracking() {
      if (!this.account) return null;

      return {
        firstName: this.account.firstName,
        lastName: this.account.lastName,
        email: this.account.email,
        familyType: this.account.accountType(),
      };
    },
  },
};
</script>
